<template>
  <a-modal
    ref="createModal"
    :title="fromType === 'edit' ? '快码数据编辑' : '新增操作'"
    :width="540"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirm"
    :confirmLoading="confirmLoading"
  >
    <a-spin :spinning="loading">
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="快码" prop="lookupType">
          <a-input v-model="defaultLookupType" :disabled="true" placeholder="请输入快码" />
        </a-form-model-item>
        <a-form-model-item label="快码id" prop="lookupTypeId" v-show="false">
          <a-input v-model="defaultLookupTypeId" :disabled="true" placeholder="请输入快码id" />
        </a-form-model-item>
        <a-form-model-item label="快码code" prop="lookupCode">
          <a-input v-model="form.lookupCode" placeholder="请输入快码code" />
        </a-form-model-item>
        <a-form-model-item label="含义" prop="lookupValue">
          <a-input v-model="form.lookupValue" placeholder="请输入含义" />
        </a-form-model-item>
        <a-form-model-item label="快码值说明" prop="lookupCode">
          <a-input v-model="form.remark" placeholder="请输入快码值说明" />
        </a-form-model-item>
        <a-form-model-item label="生效时间" prop="staDate">
          <a-date-picker
            v-model="form.staDate"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
        </a-form-model-item>
        <a-form-model-item label="失效时间" prop="endDate">
          <a-date-picker
            v-model="form.endDate"
            format="YYYY-MM-DD HH:mm:ss"
            :show-time="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }"
          />
        </a-form-model-item>
        <a-form-model-item v-for="(item) in attributeList" :key="item.key" :label="!item.tblValue ? item.tblAttribute : item.tblValue" :prop="item.tblAttribute">
          <a-input v-model="form[item.tblAttribute]" :placeholder="`请输入${!item.tblValue ? item.tblAttribute : item.tblValue}`" />
        </a-form-model-item>
      </a-form-model>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment';
import cloneDeep from 'lodash.clonedeep'
import { apiLookupDataAdd, apiLookupDataUpdate } from '@/api/system/lookup/look-up-detail'
// 表单字段
export default {
  props: {
    attributeList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      defaultLookupType: '',
      defaultLookupTypeId: '',
      // 状态数据字典
      statusOptions: [
        {
          dictLabel: "正常",
          dictValue: "0"
        },
        {
          dictLabel: "停用",
          dictValue: "1"
        }
      ],
      isDefaultOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      loading: false,
      labelCol: {
        xs: { span: 12 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 }
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        lookupValue: [
          { required: true, message: '含义不能为空', trigger: 'blur' }
        ],
        lookupCode: [
          { required: true, message: '快码code不能为空', trigger: 'blur' }
        ],
        lookupSort: [
          { required: true, message: '显示排序不能为空', trigger: 'blur' }
        ]
      },
      fromType: ""
    }
  },
  created () {
    // this.getDicts('sys_normal_disable').then(response => {
    //   this.statusOptions = response.data
    // })
  },
  methods: {
    moment,
    // 由于要用传进来的值做判断,将显示和隐藏放在内部做处理
    show (data, defaultLookupType, defaultLookupTypeId) {
      // 由于传过来的也有可能是新增时要带的字典类型,所以这里通过code判断
      if (data.id) {
        this.defaultLookupType = defaultLookupType
        this.defaultLookupTypeId = defaultLookupTypeId
        // 修改行为
        this.form = Object.assign({}, data) || {}
        this.fromType = "edit"
      } else {
        this.defaultLookupType = defaultLookupType
        this.defaultLookupTypeId = defaultLookupTypeId
        // 新增行为
        this.reset()
        this.fromType = "add"
      }
      this.visible = true
    },
    // 关闭模态框
    close () {
      this.visible = false
      this.reset()
    },
    // 保存
    confirm () {
      this.confirmLoading = true
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          // 摆场类型-促销名称特殊化校验，要确保生效时间、失效时间、attribute1必填
          if (this.defaultLookupType === 'SCP_PLACEMENT_PROMOTION_NAME') {
            const requiredList = []
            if (!this.form?.staDate) { requiredList.push('生效时间') }
            if (!this.form?.endDate) { requiredList.push('失效时间') }
            if (!this.form?.attribute1) { requiredList.push('attribute1') }
            if (requiredList?.length > 0) {
              this.$message.warning(`促销名称的${requiredList.join('、')}不能为空`)
              this.confirmLoading = false
              return
            }
          }
          this.form.lookupType = this.defaultLookupType
          this.form.lookupTypeId = this.defaultLookupTypeId
          const params = cloneDeep(this.form)
          if (params?.staDate) { params.staDate = this.$moment(params.staDate).format('YYYY-MM-DD HH:mm:ss') }
          if (params?.endDate) { params.endDate = this.$moment(params.endDate).format('YYYY-MM-DD HH:mm:ss') }
          // 进行新增行为:
          if (this.fromType === "edit") {
            // 刷新表格
            apiLookupDataUpdate(params).then(response => {
              if (response.code === 200) {
                this.$message.success('修改成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success')
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          } else {
            // 新增
            apiLookupDataAdd(params).then(response => {
              if (response.code === 200) {
                this.$message.success('新增成功')
                // 关闭本组件
                this.visible = false
                // 调用外部刷新列表方法
                this.$emit('handle-success')
                // 刷新表单
                this.reset()
                this.confirmLoading = false
              } else {
                this.$message.error(response.msg)
                this.confirmLoading = false
              }
            }).finally(() => {
              this.confirmLoading = false
            })
          }
        } else {
          return (this.confirmLoading = false)
        }
      })
    },
    // 表单重置
    reset () {
      this.$nextTick(() => {
        this.form = {}
        this.$refs.ruleForm.resetFields();
      })
    }
  }
}
</script>

<style  scoped lang="less">
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
input{
  width: 195px;
}
</style>
